import type { FC } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import GridErrorBoundaryFallback from './GridErrorBoundaryFallback';
import CreativeTextForm from './CreativeTextForm';

const AddCreativeText: FC = () => {
  return (
    <ErrorBoundary FallbackComponent={GridErrorBoundaryFallback}>
      <CreativeTextForm />
    </ErrorBoundary>
  );
};

export default AddCreativeText;